import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type RemoveAllowedCustomerMutationVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  userId: Types.Scalars['bigint']['input'];
}>;


export type RemoveAllowedCustomerMutation = { __typename?: 'mutation_root', delete_usertocustomers?: { __typename?: 'usertocustomers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'usertocustomers', customer_id: number, user_id: number }> } | null };


export const RemoveAllowedCustomerDocument = gql`
    mutation removeAllowedCustomer($customerId: bigint!, $userId: bigint!) {
  delete_usertocustomers(
    where: {_and: {customer_id: {_eq: $customerId}, user_id: {_eq: $userId}}}
  ) {
    affected_rows
    returning {
      customer_id
      user_id
    }
  }
}
    `;
export type RemoveAllowedCustomerMutationFn = Apollo.MutationFunction<RemoveAllowedCustomerMutation, RemoveAllowedCustomerMutationVariables>;

/**
 * __useRemoveAllowedCustomerMutation__
 *
 * To run a mutation, you first call `useRemoveAllowedCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllowedCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllowedCustomerMutation, { data, loading, error }] = useRemoveAllowedCustomerMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveAllowedCustomerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAllowedCustomerMutation, RemoveAllowedCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAllowedCustomerMutation, RemoveAllowedCustomerMutationVariables>(RemoveAllowedCustomerDocument, options);
      }
export type RemoveAllowedCustomerMutationHookResult = ReturnType<typeof useRemoveAllowedCustomerMutation>;
export type RemoveAllowedCustomerMutationResult = Apollo.MutationResult<RemoveAllowedCustomerMutation>;
export type RemoveAllowedCustomerMutationOptions = Apollo.BaseMutationOptions<RemoveAllowedCustomerMutation, RemoveAllowedCustomerMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/removeAllowedCustomer.mutation.gql}
 */
export async function removeAllowedCustomer(
  variables: RemoveAllowedCustomerMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<RemoveAllowedCustomerMutation['delete_usertocustomers']>
export async function removeAllowedCustomer(
  variables: RemoveAllowedCustomerMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<RemoveAllowedCustomerMutation>
export async function removeAllowedCustomer(
  variables: RemoveAllowedCustomerMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<RemoveAllowedCustomerMutation['delete_usertocustomers'] | RemoveAllowedCustomerMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<RemoveAllowedCustomerMutation>(
    RemoveAllowedCustomerDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_usertocustomers
}